import { computed, makeObservable } from 'mobx';
import {auth} from 'main/tools';
import CalendarEvent from './CalendarEvent';

class BlockedDateEvent extends CalendarEvent {
  constructor(other) {
    super();

    makeObservable(this, {
      backgroundColor: computed,
      textColor: computed,
      borderColor: computed,
      canViewDetails: computed
    });
    this.merge(other);
  }

  get backgroundColor() {
    return '#EB4D28';
  }

  get textColor() {
    return '#FFFFFF';
  }

  get borderColor() {
    return '#EB4D28';
  }

  get canViewDetails() {
    return auth.hasAccess('::MANAGE_TIME_OFF');
  }
}

export default BlockedDateEvent;
